<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          icon="fa-plus"
          v-on:click="onClickButton"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ModelList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ModelList from '@/components/settings/stock-registers/model/ModelList'
  import ActionButton from '@/components/button/ActionButton'

  export default {
    name: 'Model',
    components: {
      PageTitle,
      ActionButton,
      PageRowWrapper,
      ModelList
    },
    methods: {
    onClickButton (e) {
      this.$router.push({ name: 'addmodel' })
    }
  }
  }
</script>
